<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <b-row class="justify-content-center">
            <b-col md="7" class="mt-3" v-if="anfrage.id !== 'testid'">
                <b-card-group>
                    <b-card id="auftrag1" ref="el">
                        <div slot="header"
                              style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
                            Anfrage von: <strong>{{anfrage.sender_group}}</strong>
                        </div>
                        <b-row style="border-bottom: 1px solid #ccc!important;">
                            <b-col sm="6">
                                <b-form-group
                                        label="Anfragesteller:"
                                        label-for="auftraggeber"
                                >
                                    <b-form-input
                                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                            disabled
                                            id="auftraggeber"
                                            type="text"
                                            :placeholder="anfrage.sender_user"
                                            v-model="anfrage.sender_user"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group
                                        label="Zieltermin an/bis:"
                                        label-for="date"
                                >
                                    <datetime
                                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                            :disabled="isEditMode || wasAccepted"
                                            v-model="anfrage.finish_till"
                                            input-class="form-control"
                                            input-style="color: black;"
                                            input-id="date"
                                            :aria-placeholder="formateDate(anfrage.finish_till)"
                                            :phrases="datetimeConfig.phrases"
                                            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                                            :min-datetime="datetimeConfig.minTime"></datetime>

                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row style="border-bottom: 1px solid #ccc!important;">
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2">
                                <p class="p-center">Anfragentitel:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        class="bold-text"
                                        :disabled="anfrage.offen > 0 || anfrage.art === 'DE' || !canInteract || isMe || wasAccepted"
                                        type="text"
                                        v-model="anfrage.title"
                                        :placeholder="anfrage.title"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                        <b-row v-if="hasContact">
                            <b-col sm="2">
                                <p class="p-center">Für Rückfragen:</p>
                            </b-col>
                            <b-col>
                                <b-form-textarea
                                        class="text-black"
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                        disabled
                                        type="text"
                                        v-model="contact"
                                        :placeholder="contact"
                                        wrap="hard"
                                        rows="3"
                                        :max-rows="maxrows"
                                >
                                </b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2"></b-col>
                            <b-col>
                                <b-form-textarea id="info-box" ref="infoBox"
                                                 class="text-black"
                                                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                                 :placeholder="anfrage.message"
                                                 :rows="8"
                                                 :max-rows="maxrows"
                                                 wrap="hard"
                                                 :disabled="isEditMode || wasAccepted"
                                                 v-model="anfrage.message"

                                ></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2">
                                <p class="p-center">Datum:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        :placeholder="formateDate(anfrage.create_date)"
                                >
                                </b-form-input>
                            </b-col>

                            <b-col sm="2">
                                <p class="p-center">Unterschrift:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        v-model="anfrage.sender_user"
                                        :placeholder="anfrage.sender_user"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-card-group>
            </b-col>
            <b-col md="5" class="mt-3" v-if="anfrage.id !== 'testid'">
                <b-card>
                    <b-row style="gap: 10px">
                            <b-button v-if="anfrage.art === 'AF' && isAufgabe" variant="success" class="btn-pill font-lg" v-on:click="gotoAuftragAufgabe">
                                Zur Aufgabe
                            </b-button>
                            <b-button v-if="anfrage.art === 'AF' && isAuftrag" variant="success" class="btn-pill font-lg" v-on:click="gotoAuftragAufgabe">
                                Zum Auftrag
                            </b-button>
                            <b-button v-if="anfrage.art === 'AF' && !wasAccepted" :disabled="isMe" variant="success" class="btn-pill font-lg" v-on:click="showAccept = true">
                                Anfrage annehmen
                            </b-button>
                            <b-button v-if="anfrage.art === 'AF' && !wasAccepted" :disabled="isMe" variant="danger" class="btn-pill font-lg" v-on:click="showDeny = true">
                                Anfrage ablehnen
                            </b-button>
                            <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
                                Zurück
                            </b-button>
                    </b-row>
                </b-card>
                <b-card>
                    <div slot="header">
                        Anhänge
                    </div>
                    <b-row>
                        <b-col>
                            <b-list-group>
                                <b-list-group-item
                                        button
                                        class="d-flex justify-content-between align-items-center"
                                        v-for="item in attachments"
                                        v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                                    {{item.file_name}}
                                    <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                                        {{formatBytes(item.file_size)}}
                                    </b-badge>
                                </b-list-group-item>
                            </b-list-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="anfrage.art === 'DE'">
                    <div slot="header">
                        Abgelehnt
                    </div>
                    <b-row>
                        <b-col>
                            <b-form-group
                                    label="Abgelehnt von:"
                                    label-for="denied_by"
                            >
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                        disabled
                                        id="denied_by"
                                        type="text"
                                        :placeholder="anfrage.declining_user"
                                        v-model="anfrage.declining_user"
                                >
                                </b-form-input>
                            </b-form-group>
                            <b-form-group
                                    label="Abgelehnt am:"
                                    label-for="denied_at"
                            >
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                        disabled
                                        id="denied_at"
                                        type="text"
                                        :placeholder="formateDate(anfrage.decline_date)"
                                >
                                </b-form-input>
                            </b-form-group>
                            <b-form-textarea id="info-box" ref="infoBox"
                                             class="text-black"
                                             :placeholder="anfrage.decline_note"
                                             rows="6"
                                             max-rows="40"
                                             :disabled="true"
                                             v-model="anfrage.decline_note"

                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="anfrage.lat !== 0.0 && anfrage.lon !== 0.0">
                    <div slot="header">
                        Position
                    </div>
                    <b-row style="margin-bottom: 0">
                        <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container"
                               ref="map_container">
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>

        </b-row>
        <beautiful-chat
                v-if="hasChat"
                :participants="participants"
                :onMessageWasSent="onMessageWasSent"
                :messageList="messageList"
                :newMessagesCount="newMessagesCount"
                :isOpen="isChatOpen"
                :close="closeChat"
                :open="openChat"
                :showEmoji="false"
                :showFile="true"
                :showTypingIndicator="showTypingIndicator"
                :showLauncher="true"
                :showCloseButton="true"
                :colors="colors"
                :alwaysScrollToBottom="alwaysScrollToBottom"
                :messageStyling="messageStyling"
                :disable-user-input="disableChat"
                :placeholder="messagePlaceholder"
                @file_clicked="onFileClicked"
        >
          <template v-slot:header>
            <div class="sc-header--title ">
              Nachrichten:
            </div>
          </template>
            <template v-slot:user-avatar="{ message, user }">
                <div>
                </div>
            </template>
            <template v-slot:text-message-body="{ message }">
                <p style='font-weight: bold; margin-bottom: 3px; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; margin-left: -12px'>
                    {{message.data.meta_name}}:
                </p>
                <p style="margin-left: -12px; margin-bottom: 8px; white-space: pre-wrap;">{{message.data.text}}</p>
                <p style="text-align: right; font-weight: lighter; font-size: 12px; margin-bottom: 0px; margin-top: 8px; margin-right: -12px">
                    {{message.data.meta}}
                </p>
            </template>
            <template v-slot:text-message-toolbox="{ message }">
            </template>
        </beautiful-chat>
        <b-modal size="sm" v-model="showUserList" id="modal-center" centered title="Nutzer einladen"
                 body-class="my-body" @ok="onAddUserToChat">
            <b-table striped bordered hover responsive id="my-table" :items="userList"
                     :fields="userFields" class="mb-0" selectable thead-class="hidden_header"
                     selectedVariant="success"
                     @row-selected="onUserSelect"
                     select-mode="single"
            >
            </b-table>
            <template #modal-footer="{ok, cancel}">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="md" variant="primary" @click="cancel()">
                    Abbrechen
                </b-button>
                <b-button size="md" variant="success" @click="ok()">
                    Einladen
                </b-button>
            </template>
        </b-modal>
        <b-modal size="sm" v-model="showDeny" id="modal-center" centered title="Anfrage ablehnen"
                 body-class="my-body" @ok="denyAnfrage">
            <form>
                <b-form-textarea
                        class="text-black"
                        placeholder="Ablehnungsnachricht"
                        rows="6"
                        max-rows="40"
                        wrap="hard"
                        v-model="denyMessage"
                        style="min-height: 150px"

                ></b-form-textarea>
            </form>
            <template #modal-footer="{ok, cancel}">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="md" variant="primary" @click="cancel()">
                    Abbrechen
                </b-button>
                <b-button size="md" variant="danger" @click="ok()">
                    Ablehnen
                </b-button>
            </template>
        </b-modal>
        <b-modal size="md" v-model="showAccept" centered title="Anfrage annehmen"
                 @ok="acceptAnfrage">
            <b-row>
                <b-col style="border-right: 1px solid grey;">
                    <b-form-checkbox
                            v-model="acceptSelf"
                            @change="changeSelf"
                    >
                        Aufgabe an
                    </b-form-checkbox>
                    <b-form-select :options="a_select" id="a_geber" :plain="true"
                                   v-model="a_geber"
                                   :disabled="acceptOther"
                                   class="mb-2 text-black mt-2"></b-form-select>
                </b-col>
                <b-col style="border-left: 1px solid grey;">
                    <b-form-checkbox
                            v-model="acceptOther"
                            @change="changeOther"
                    >
                        Auftrag an
                    </b-form-checkbox>
                    <b-form-select :options="an_select" id="a_nehmer" :plain="true"
                                   v-model="a_nehmer"
                                   :disabled="acceptSelf"
                                   class="mb-2 text-black mt-2"
                    ></b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-alert v-model="show_alert" variant="danger">Bitte wählen Sie zuerst aus, ob aus der Anfrage eine Aufgabe im Web oder ein Auftrag an den Bauhof übermittelt werden soll.</b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <form>
                        <b-form-textarea
                                class="text-black"
                                placeholder="Annahmenachricht"
                                rows="6"
                                max-rows="40"
                                wrap="hard"
                                v-model="acceptMessage"
                                style="min-height: 150px"

                        ></b-form-textarea>
                    </form>
                </b-col>
            </b-row>
            <template #modal-footer="{ok, cancel}">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="md" variant="primary" @click="cancel()">
                    Abbrechen
                </b-button>
                <b-button size="md" variant="success" @click="acceptAnfrage">
                    Annehmen
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import {DateTime as LuxonDateTime} from 'luxon'
    import {Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
    import {decryptAES, decryptFile, decryptMessages, encryptAES, encryptFile} from "../../../shared/crypto";
    import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';


    export default {
        name: "anfrage",
        components: {
            AccountMultiplePlusIcon
        },
        props:{
            onFileClicked: {
                type: Function,
                default: undefined
            },
            onFileOk: {
                type: Function,
                default: undefined
            },
            onAttachment: {
                type: Function,
                default: undefined
            },
            responseError: {
                type: Function,
                default: undefined
            },
            showLoader: {
                type: Function,
                default: undefined
            },
            hideLoader: {
                type: Function,
                default: undefined
            },
        },
        computed: {
            isEditMode() {
                return !this.editMode;
            }
        },
        data: () => {
            return {
                anfrage: {
                    id: "testid",
                    art: "",
                    offen: 0,
                    module: "mm",
                    lat: 0.0,
                    lon: 0.0,
                    title: "",
                    message: "",
                    finish_till: null,
                    sender_group: "",
                    sender_user: "",
                    receiving_group: "",
                    receiving_user: "",
                    declining_group: "",
                    declining_user: "",
                    decline_date: "",
                    decline_note: "",
                    custom_properties: "",
                    create_date: ""
                },
                attachments: [],
                datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
                maxrows: 40,
                editMode: true,
                textBackup: undefined,
                dateBackup: undefined,
                userId: "",
                interval: null,

                // chat specific
                hasChat: false,
                disableChat: false,
                messagePlaceholder: "Nachricht schreiben...",
                participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
                messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
                newMessagesCount: 0,
                isChatOpen: false, // to determine whether the chat window should be open or closed
                showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
                colors: {
                    header: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    launcher: {
                        bg: '#4e8cff'
                    },
                    messageList: {
                        bg: '#ffffff'
                    },
                    sentMessage: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    receivedMessage: {
                        bg: '#eaeaea',
                        text: '#222222'
                    },
                    userInput: {
                        bg: '#f4f7f9',
                        text: '#565867'
                    }
                }, // specifies the color scheme for the component
                alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
                messageStyling: false, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
                showUserList: false,
                userList: [],
                userFields: [{
                    key: 'full_name', label: 'Name', formatter: (value, key, item) => {
                        if (item === null) {
                            return null;
                        }
                        let res = JSON.parse(sessionStorage.getItem(item.id));
                        if (res === null) {
                            return value;
                        }
                        return res.full_name;
                    }
                },],
                selectedUsers: [],
                url: "",
                download: "",

                denyMessage: "Ihre Mängelmeldung wurde von Ihrer Kommune abgelehnt.",
                showDeny: false,
                showAccept: false,
                showAcceptMessage: false,
                acceptMessage: "Ihre Mängelmeldung wird nun bearbeitet.\nSobald der Mangel behoben wurde wird Ihnen eine Fertigstellungsmeldung zugesandt.",
                acceptSelf: false,
                acceptOther: false,
                a_select: [],
                an_select: [{text: "Bauhof", value: "Bauhof"}],
                a_nehmer: "Bauhof",
                a_geber: null,
                groups: [],
                hasContact: false,
                contact: "",
                allGroups: {},
                isMe: false,
                canInteract: true,
                wasAccepted: false,
                isAuftrag: false,
                isAufgabe: false,
                show_alert: false,
            }
        },
        beforeDestroy: function () {
            window.clearInterval(this.interval);
        },
        methods: {
            gotoAuftragAufgabe() {
                this.$router.push("/auftraege/auftrag/"+this.$route.params.id);
            },
            formateDate(date) {
                if (date === null) {
                    return ""
                }
                let event = new Date(date.replace('Z', ''));
                let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
                return event.toLocaleDateString('de-DE', options);
            },
            print() {
                this.$htmlToPaper('auftrag1', () => {
                });
            },
            toggleEditMode(save) {
                if (save === undefined) {
                    this.textBackup = this.anfrage.message;
                    this.dateBackup = this.anfrage.finish_till;
                } else if (save === false) {
                    this.anfrage.message = this.textBackup;
                    this.anfrage.finish_till = this.dateBackup;
                } else {
                    this.textBackup = this.anfrage.message;
                    this.dateBackup = this.anfrage.finish_till;
                    let data = {
                        id: this.anfrage.id,
                        ziel: this.anfrage.finish_till,
                        text: this.anfrage.message,
                    };
                    this.showLoader();
                    this.$http.post(
                        Server_URL + '/auftragsbuch/data/update',
                        data
                    ).then(this.onEditResponseOk, this.responseError)
                }
                this.editMode = !this.editMode;
            },
            onEditResponseOk(response) {
                this.hideLoader();
                if (response.status === 200) {
                } else {
                    window.location = Redirect_500;
                }
            },
            responseOkFetch(response) {
                if (response.status === 200 && response.body.status === "ok") {
                    this.userId = response.body.session.id;
                    let data = response.body.data;
                    if (sessionStorage.getItem("aes") !== null) {
                        this.decryptData(data.anfrage.message, data.anfrage.decline_note, data.anfrage.art).then(res => {
                            data.anfrage.message = res[0];
                            data.anfrage.decline_note = res[1];
                            this.setData(data);
                        }).catch(e => {
                            this.setData(data);

                        });
                    } else {
                        this.setData(data);
                    }
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            async decryptData(message, decline, art) {
                try {
                    if (message !== null && message !== "") {
                        message = await decryptAES(sessionStorage.getItem("aes"), message);
                    }
                } catch (e) {
                }
                try {
                    if (decline !== null && decline !== "" && art === "DE") {
                        decline = await decryptAES(sessionStorage.getItem("aes"), decline);
                    }
                } catch (e) {
                }
                return [message, decline]
            },
            setData(data) {
                if (data.data.id !== "" && data.data.a_nehmer === "Bauhof") {
                    this.isAuftrag = true;
                } else if (data.data.id !== "") {
                    this.isAufgabe = true;
                }
                this.anfrage = data.anfrage;
                this.allGroups = data.all_groups;
                this.wasAccepted = data.anfrage.offen !== 0;
                this.hideLoader();
                this.groups = data.groups;
                for (let i = 0; i < this.groups.length; i++) {
                    if (this.groups[i].name === this.anfrage.receiving_group) {
                        this.canInteract = true;
                    }
                    let res = JSON.parse(sessionStorage.getItem(this.groups[i].name));
                    if (res !== null) {
                        this.a_select.push({text: res.username, value: this.groups[i]});
                    } else {
                        this.a_select.push({text: this.groups[i].name, value: this.groups[i]});
                    }
                }
                if (this.$cookies.get("ps_user_id") === this.anfrage.receiving_user) {
                    this.canInteract = true;
                }
                this.contact = "";
                if (this.anfrage.module === "mm") {
                    let defectData = JSON.parse(this.anfrage.custom_properties);
                    let hasContact = defectData.name !== "" || defectData.email !== "" || defectData.phone_number !== "";
                    if (hasContact) {
                        if (defectData.name !== "") {
                            this.contact += "Name: " + defectData.name + "\n"
                        }
                        if (defectData.email !== "") {
                            this.contact += "Email: " + defectData.email + "\n"
                        }
                        if (defectData.phone_number !== "") {
                            this.contact += "Tel: " + defectData.phone_number + "\n"
                        }
                    }
                }
                this.hasContact = this.contact !== "";
                if (this.anfrage.sender_group === "mm") {
                    this.anfrage.sender_group = "Mängelmelder";
                    if (this.anfrage.sender_user === "") {
                        this.anfrage.sender_user = "Unbekannt";
                    }
                } else {
                    this.denyMessage = "";
                    this.acceptMessage = "";
                    this.isMe = this.$cookies.get("ps_user_id") === this.anfrage.sender_user;
                    let res = JSON.parse(sessionStorage.getItem(this.anfrage.sender_user));
                    if (res !== null) {
                        this.anfrage.sender_user = res.full_name;
                    }
                    res = JSON.parse(sessionStorage.getItem(this.anfrage.sender_group));
                    if (res !== null) {
                        this.anfrage.sender_group = res.username;
                    } else if (this.anfrage.sender_group in this.allGroups) {
                        this.anfrage.sender_group = this.allGroups[this.anfrage.sender_group];
                    }
                }
                if (this.isMe || !this.canInteract || this.anfrage.art === "DE") {
                    this.editMode = false;
                }

                if (this.anfrage.art === "DE") {
                    this.disableChat = true;
                    this.messagePlaceholder = "Die Anfrage ist abgelehnt."
                    let res = JSON.parse(sessionStorage.getItem(this.anfrage.declining_user));
                    if (res !== null) {
                        this.anfrage.declining_user = res.full_name;
                    }
                }
                this.$nextTick(() => {
                    this.showMapIfNeeded();
                });
                this.attachments = data.attachments;
                this.hasChat = data.has_chat;

                if (this.hasChat) {
                    for (let i = 0; i < data.authors.length; i++) {
                        let res = JSON.parse(sessionStorage.getItem(data.authors[i].id));
                        if (res !== null) {
                            data.authors[i].name = res.full_name;
                        }
                    }
                    this.participants = data.authors;
                    if (sessionStorage.getItem("aes") !== null) {
                        decryptMessages(sessionStorage.getItem("aes"), data.messages).then(res => {
                            this.messageList = res;
                            if (this.messageList.length !== 0) {
                                this.isChatOpen = true;
                            }
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        }).catch(err => {

                            this.messageList = data.messages;
                            if (this.messageList.length !== 0) {
                                this.isChatOpen = true;
                            }
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        })
                    } else {
                        this.messageList = data.messages;
                        if (this.messageList.length !== 0) {
                            this.isChatOpen = true;
                        }
                        if (this.interval === null) {
                            this.interval = setInterval(this.refresh, 2000);
                        }
                    }
                }
            },
            formatBytes(bytes, decimals = 2) {
                if (bytes === 0) return '0 Bytes';

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            back() {
                this.$router.go(-1);
            },
            openChat() {
                // called when the user clicks on the fab button to open the chat
                this.isChatOpen = true
                this.newMessagesCount = 0
            },
            closeChat() {
                // called when the user clicks on the botton to close the chat
                this.isChatOpen = false
            },
            onMessageWasSent(message) {
                // called when the user sends a message
                if (this.interval !== null) {
                    clearInterval(this.interval);
                    this.interval = null;
                }
                if (message.type === "text") {
                    let body = {
                        data_id: this.anfrage.id,
                        data_beleg_ex: this.anfrage.title,
                        message: message.data.text,
                    };
                    if (this.messageList.length > 0) {
                        body.create_date = this.messageList[this.messageList.length - 1].data.meta_date;
                    }
                    if (sessionStorage.getItem("aes") !== null) {
                        encryptAES(sessionStorage.getItem("aes"), body.message).then(res => {
                            body.plain_text = body.message;
                            body.plain_name = JSON.parse(sessionStorage.getItem(this.userId)).full_name;
                            body.message = res;
                            this.$http.post(
                                Server_URL + '/auftragsbuch/data/message', body
                            ).then(this.onNewMessages, this.responseError)
                        })
                    } else {
                        this.$http.post(
                            Server_URL + '/auftragsbuch/data/message', body
                        ).then(this.onNewMessages, this.responseError)
                    }
                } else {
                    if (sessionStorage.getItem("aes") !== null) {
                        this.showLoader();
                        const reader = new FileReader();
                        reader.addEventListener('load', (event) => {
                            let buf = new Uint8Array(event.target.result);
                            encryptFile(sessionStorage.getItem("aes"), buf).then(res => {
                                const b = new Blob([res], {type: message.data.file.type});
                                let lastDate = "";
                                if (this.messageList.length > 0) {
                                    lastDate = this.messageList[this.messageList.length - 1].data.meta_date;
                                }
                                let formData = new FormData();
                                formData.append('upload_file', b, message.data.file.name);
                                this.$http.post( Server_URL+'/auftragsbuch/data/file_message/'
                                    +this.$route.params.id+"?plain_name=" + JSON.parse(sessionStorage.getItem(this.userId)).full_name + "&last_date=" + lastDate,
                                    formData,
                                    {
                                        headers: {
                                            'Content-Type': 'multipart/form-data'
                                        }
                                    }
                                ).then(this.onNewMessages, this.responseError)
                            }).catch(err => {
                                this.hideLoader();
                            })
                        });
                        reader.readAsArrayBuffer(message.data.file);
                    } else {
                        let lastDate = "";
                        if (this.messageList.length > 0) {
                            lastDate = this.messageList[this.messageList.length - 1].data.meta_date;
                        }
                        let formData = new FormData();
                        formData.append('upload_file',message.data.file);
                        this.$http.post( Server_URL+'/auftragsbuch/data/file_message/'
                            +this.$route.params.id+"?plain_name=xxx"+"&last_date=" + lastDate,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        ).then(this.onNewMessages, this.responseError)
                    }
                }
            },
            onNewMessages(response) {
                if (response.status === 200) {
                    if (response.body.authors !== undefined) {
                        for (let i = 0; i < response.body.authors.length; i++) {
                            let found = false;
                            for (let j = 0; j < this.participants.length; j++) {
                                if (this.participants[j].id === response.body.authors[i].id) {
                                    found = true;
                                    break
                                }
                            }
                            if (!found) {
                                let res = JSON.parse(sessionStorage.getItem(response.body.authors[i].id));
                                if (res !== null) {
                                    response.body.authors[i].name = res.full_name;
                                }
                                this.participants.push(response.body.authors[i]);
                            }
                        }
                    }
                    if (sessionStorage.getItem("aes") !== null) {
                        decryptMessages(sessionStorage.getItem("aes"), response.body.messages).then(res => {
                            for (let i = 0; i < res.length; i++) {
                                this.messageList.push(res[i]);
                            }
                            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + res.length;
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        })
                    } else {
                        for (let i = 0; i < response.body.messages.length; i++) {
                            this.messageList.push(response.body.messages[i]);
                        }
                        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + response.body.messages.length;
                        if (this.interval === null) {
                            this.interval = setInterval(this.refresh, 2000);
                        }
                    }
                    this.hideLoader();
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            refresh() {
                let url = Server_URL + '/auftragsbuch/data/messages/' + this.anfrage.id;
                if (this.messageList.length !== 0) {
                    url += "?last_date=" + encodeURIComponent(this.messageList[this.messageList.length - 1].data.meta_date);
                }
                this.$http.get(
                    url
                ).then(this.onNewMessages, this.responseErrorTrap)
            },
          responseErrorTrap(response) {
            if (response.status === 401) {
              window.location = Redirect_Login;
            } else {
              console.log(response);
            }
          },
            onAddUsers() {
                this.showUserList = true;
                this.selectedUsers = [];
                this.showLoader();
                this.$http.get(
                    Server_URL + '/auftragsbuch/data/users'
                ).then(this.responseOkFetchUsers, this.responseError)
            },
            responseOkFetchUsers(response) {
                if (response.status === 200) {
                    this.hideLoader();
                    let users = [];
                    for (let i = 0; i < response.body.length; i++) {
                        let found = false;
                        for (let j = 0; j < this.participants.length; j++) {
                            if (response.body[i].id === this.participants[j].id) {
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            users.push(response.body[i]);
                        }
                    }
                    this.userList = users;
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            onUserSelect(items) {
                this.selectedUsers = items;
            },
            onAddUserToChat() {
                if (this.selectedUsers.length === 0) {
                    return
                }
                let payload = {};
                if (sessionStorage.getItem("aes") !== null) {
                    payload = {
                        data_id: this.anfrage.id,
                        plain_name: JSON.parse(sessionStorage.getItem(this.userId)).full_name,
                        recipient_id: this.selectedUsers[0].id,
                        recipient_plain_name: JSON.parse(sessionStorage.getItem(this.selectedUsers[0].id)).full_name,
                    }
                } else {
                    payload = {
                        data_id: this.anfrage.id,
                        recipient_id: this.selectedUsers[0].id,
                        recipient_plain_name: this.selectedUsers[0].full_name,
                    }
                }
                this.showLoader();
                this.$http.post(
                    Server_URL + '/auftragsbuch/data/message/invite', payload
                ).then(this.responseOkInvite, this.responseError)
            },
            responseOkInvite(response) {
                if (response.status === 200) {
                    this.hideLoader();
                    this.participants.push(response.body);
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            acceptAnfrage() {
                if(this.acceptSelf === false && this.acceptOther === false) {
                    this.show_alert = true;
                    return;
                }

                if (this.acceptSelf) {
                    let data = {
                        gi_memo: this.anfrage.message,
                        ziel_datum: this.anfrage.finish_till === "" ? null : this.anfrage.finish_till,
                        gi_auf_ext: this.anfrage.title,
                        group_name: this.a_geber.name,
                        group_id: this.a_geber.name,
                        annahme_note: this.acceptMessage,
                        gi_memo_plain: this.anfrage.message,
                    };
                    if (sessionStorage.getItem("aes") !== null) {
                        this.showLoader();
                        encryptAES(sessionStorage.getItem("aes"), data.gi_memo).then(res => {
                            data.gi_memo = res;
                            this.startUpload(data);
                        }).catch(res => {
                        })
                    } else {
                        this.showLoader();
                        this.startUpload(data)
                    }
                } else {
                    this.showLoader();
                    let data = {
                        gi_memo: this.anfrage.message,
                        ziel_datum: this.anfrage.finish_till === "" ? null : this.anfrage.finish_till,
                        gi_auf_ext: this.anfrage.title,
                        annahme_note: this.acceptMessage,
                    };
                    this.$http.post(
                        Server_URL+'/auftragsbuch/data/anfrage_change/'+ this.anfrage.id,
                        data
                    ).then(this.responseRedirectCreate, this.responseError)
                }
                this.showAccept = false;
            },
            startUpload(payload) {
                this.$http.post(
                    Server_URL+'/auftragsbuch/data/accept/'+ this.anfrage.id,
                    payload
                ).then(this.responseOkReload, this.responseError)
            },
            denyAnfrage() {
                this.showLoader();
                let payload ={
                    deny_message: this.denyMessage
                };
                this.$http.post(
                    Server_URL + '/auftragsbuch/data/deny/'+ this.anfrage.id, payload
                ).then(this.responseOkReload, this.responseError)
            },
            responseOkReload() {
                this.$http.get(
                    Server_URL + '/auftragsbuch/data/single/' + this.$route.params.id
                ).then(this.responseOkFetch, this.responseError)
            },
            responseRedirectCreate() {
                this.hideLoader();
                // todo redirect
                this.$router.push("/create?data_id=" + this.$route.params.id);
            },
            showMapIfNeeded() {

                if (this.map !== undefined || this.anfrage.lat === 0.0 || this.anfrage.lon === 0.0) {
                    return;
                }

                mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
                this.map = new mapboxgl.Map({
                    container: 'map_container',
                    style: 'mapbox://styles/mapbox/outdoors-v11',
                    center: [this.anfrage.lon, this.anfrage.lat],
                    zoom: 18,
                    minZoom: 5,
                    maxPitch: 0,
                    attributionControl: false
                });

                this.map.addControl(new ZoomControl(), 'bottom-right');
                const languageControl = new LanguageControl({
                    language: 'de',
                });
                this.map.addControl(languageControl);

                this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

                this.marker = null;
                this.geojson = {};
                this.map.on('load', this.mapLoad);
            },
            mapLoad() {
                setTimeout(() => {
                    if (this.marker === null) {
                        let el = document.createElement('div');
                        el.className = 'marker';

                        this.marker = new mapboxgl.Marker({
                            element: el,
                            anchor: 'center',
                        })
                            .setLngLat([this.anfrage.lon, this.anfrage.lat])
                            .addTo(this.map);
                    }
                    this.map.resize();
                    this.hideLoader()
                });
            },
            changeSelf(val) {
                this.show_alert = false;
                this.acceptOther = !val;
            },
            changeOther(val) {
                this.show_alert = false;
                this.acceptSelf = !val;
            },
        }
    }
</script>

<style>

    .marker {
        background-image: url('../../../../public/mangel_marker.png');
        background-size: cover;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;
    }

    .sc-message {
        width: 480px;
    }

    .sc-message--text .sc-message--toolbox {
        display: none;
    }

    .sc-launcher.opened :before {
        box-shadow: none;
    }

    .sc-launcher.opened:before {
        box-shadow: none !important;
    }

    .sc-chat-window {
      border: 1px solid lightgray !important;
      width: 520px !important;
      z-index: 5;
    }

    .sc-launcher {
      z-index: 5;
    }

    .sc-user-input {
        border-top: 1px solid lightgray !important;

    }

    .sc-user-input--text {
        width: 450px !important;
    }

    .sc-header--close-button {
        margin-left: 0 !important;
    }

    .my-body {
        padding: 0 !important;
    }

    .hidden_header {
        display: none;
    }

    .sc-user-input--file-icon-wrapper {
        margin-bottom: 0;
    }
    .sc-header {
      min-height: unset !important;
    }
</style>

<style scoped>

    .form-control:disabled, .form-control[disabled] {
        color: black !important;
    }

    .text-black {
        color: black;
    }

    .p-center {
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0;
    }

    .bold-text {
        font-weight: bold;
    }

    ::placeholder { /* Firefox, Chrome, Opera */
        color: black;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: black;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: black;
    }

</style>
